import { useAuth } from "@/context/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Store, LayoutDashboard, CalendarClock, User, LogOut, Search } from "lucide-react";

const nav = [
  { to: "/painel", label: "Painel", testid: "painel", icon: LayoutDashboard },
  { to: "/painel/vencimentos", label: "Vencimentos", testid: "vencimentos", icon: CalendarClock },
  { to: "/painel/mais-vendidas", label: "Mais vendidas", testid: "mais-vendidas", icon: Search },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 bg-card/90 backdrop-blur border-b border-border">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/painel" className="flex items-center gap-2" data-testid="header-logo">
            <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center">
              <Store className="w-5 h-5 text-primary-foreground" strokeWidth={2.2} />
            </div>
            <div className="leading-tight">
              <p className="font-display font-bold text-primary text-base">Crediário</p>
              <p className="text-xs text-muted-foreground -mt-0.5">{user?.name}</p>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/painel/perfil" data-testid="header-perfil"
              className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-primary transition-colors">
              <User className="w-4 h-4" /> Perfil
            </Link>
            <button onClick={handleLogout} data-testid="logout-button"
              className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-destructive transition-colors">
              <LogOut className="w-4 h-4" /> Sair
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 pb-28">{children}</main>

      <nav className="fixed bottom-0 inset-x-0 z-30 bg-card border-t border-border sm:hidden no-print">
        <div className="grid grid-cols-3">
          {nav.map((n) => {
            const active = location.pathname === n.to;
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={`bottomnav-${n.testid}`}
                className={`flex flex-col items-center gap-1 py-3 text-[11px] font-medium transition-colors ${active ? "text-primary" : "text-muted-foreground"}`}>
                <Icon className="w-5 h-5" strokeWidth={2} />
                {n.label}
              </Link>
            );
          })}
        </div>
      </nav>

      <div className="hidden sm:flex fixed bottom-6 left-1/2 -translate-x-1/2 z-30 bg-card border border-border rounded-full shadow-lg px-2 py-1.5 gap-1 no-print">
        {nav.map((n) => {
          const active = location.pathname === n.to;
          const Icon = n.icon;
          return (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.testid}`}
              className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-colors ${active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary"}`}>
              <Icon className="w-4 h-4" strokeWidth={2} /> {n.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
